<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object as PropType<any>,
    default: () => { }
  }
})

const lists = computed(() => {
  return props?.data?.data?.map((item: any) => {
    return {
      image: item?.image?.link,
      title: item.subject,
      category: item.categories.length > 0 ? item.categories[0].subject : '',
      date: item.publish_date,
      link: `/sustainability/article/${item?.seo?.meta_slug || item.id}`
    }
  })
})
</script>

<template>
  <ul class="lists">
    <li v-for="item in lists" :key="item.title">
      <CardCard11 :data="item" />
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.lists {
  @include grid(9, 24);
  grid-template-columns: repeat(4, 1fr);

  @include max-media(1023) {
    grid-template-columns: repeat(3, 1fr);
  }

  @include max-media(767) {
    grid-template-columns: repeat(2, 1fr);
  }

  @include max-media(480) {
    grid-template-columns: repeat(1, 1fr);
  }

  li {
    margin-bottom: toRem(56);

    @include max-media(480) {
      margin-bottom: toRem(20);
    }
  }

  :deep(.card) {
    @include max-media(480) {
      display: flex;
      align-items: flex-start;
      padding: toRem(12);

      .card {
        &__pic {
          width: toRem(80);
          height: toRem(80);
          margin-bottom: 0;
          flex-shrink: 0;
          border-radius: toRem(6);
          overflow: hidden;

          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        &__bottom {
          padding-left: toRem(12);
        }

        &__title {
          font-size: toRem(16);
          line-height: 1.6;
          @include dot-many-line(2); // margin-bottom: 0;
        }
      }
    }
  }
}
</style>
